export default __webpack_public_path__ + "static/media/flag-wales.44d5a4fa.svg";